import { SchoolInfo } from './SchoolInfo';

export default SchoolInfo;
